import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { ICONS } from 'Utils/icons';


function NavigationBar({ 
    setShowFloatingDropdown, 
    showFloatingDropdown, 
    resultIndex, 
    setResultIndex,
    totalResults, 
    totalVersions,
    //setHasFocus, 
    itemLocation, 
    setIsFocusBase, 
    setOpenBtnFocus,
    openBtn,
    setFocusKeyword,
    setActiveDrop,
    handleChange,
    resultCategories,
    categoryId,
    verResults, 
    setVerResults,
    activeDrop
}) {
    
    const handleFocusLocation = () => {
        if(itemLocation=='fixed'){
            setIsFocusBase(false);
        }
        else{
            setIsFocusBase(true);
        }
    }

    const handleResultIndexChange = (currentIndex, modifier, versionResults) => {
        if(modifier!=null){
            if(versionResults!=null){
                var newIndex = currentIndex + modifier;
                var resultsLength = versionResults.length;

                if(modifier>0){
                    var modIndex = resultsLength > newIndex ? newIndex : 0;
                    var m = versionResults[modIndex];

                    setResultIndex(modIndex);
                    setFocusKeyword(null);
                    setActiveDrop(m.deIdentifier);
                    handleChange(m.deVersionId, m.deModuleId, m);
                }
                if(modifier<0){
                    var modIndex = newIndex >= 0 ? newIndex : (resultsLength-1);
                    var m = versionResults[modIndex];

                    setResultIndex(modIndex);
                    setFocusKeyword(null);
                    setActiveDrop(m.deIdentifier);
                    handleChange(m.deVersionId, m.deModuleId, m);
                }
            }
        }
    }

    useEffect(()=>{
        // Get search results for current version
        var currentVerResults = resultCategories.filter((c)=>{
            var currentVerModuleResults = c[1].filter((m)=>{
                if(m.deVersionId==categoryId){
                    return true;
                }
                else{
                    return false;
                }
            })
            // If there are results for current version
            if(currentVerModuleResults.length>0){
                return currentVerModuleResults;
            }
            else{
                return false;
            }
        })
        
        // By default set result index to -1 (indicating no results focused)
        setResultIndex(-1);

        if(currentVerResults!=null && currentVerResults.length>0){
            // Get version search result data
            var results = currentVerResults[0];

            if(results!=null && results.length>0){
                // Loop through array of results for version at [1]
                results[1].map((h,index)=>{
                    // Set result index of active dropdown result
                    if(h.deIdentifier==activeDrop){
                        setResultIndex(index);
                    }
                    return {
                        id: h.deIdentifier,
                        ver: h.deVersionId,
                        mod: h.deModuleId
                    };
                });
                // Set verResults as array of search results for version at [1]
                setVerResults(results[1]);
            }
        }
        else{
            // No results in current version
            setVerResults([]);
        }
    },[resultCategories, categoryId]);

    return (
        <div id="ct-search-nav-test" className="d-flex flex-row justify-content-between  align-items-center small py-2 px-2 bg-color-base-lightgray ">
            <div className="pagination gap-3 flex-row align-items-center">
                <Button 
                    ref={openBtn}
                    className="rounded-0 bg-color-base-white color-base-darkgray flex-shrink-0"
                    onClick={()=>{
                        setShowFloatingDropdown(!showFloatingDropdown);
                    }}
                    onFocus={(e) => {
                        handleFocusLocation();
                        //setHasFocus(true);
                        setOpenBtnFocus(true);
                    }}
                    onBlur={(e) => {
                        //setHasFocus(false);
                        setOpenBtnFocus(false);
                    }}
                    title={showFloatingDropdown==true ?  "Close search results" : "Open search results"}
                >
                    <div>
                        {showFloatingDropdown==true ? ICONS.hamburgerOpen() : ICONS.hamburger() }
                        <span class="visually-hidden">{showFloatingDropdown==true ?  "Close" : "Open"}</span>
                    </div>
                </Button>
                <p className="mb-0 d-block body semibold">{totalResults} results across {totalVersions} Versions</p>
            </div>
            <div className="d-flex flex-row align-items-center ">
                <p className="mb-0 d-block body semibold me-2 nav-result-index">{resultIndex + 1} of {verResults.length}</p>
                <div className="pagination d-flex gap-2">
                    <Button 
                        title="Go to previous search result"
                        disabled={totalResults==0 || verResults.length<1}
                        className="rounded-0 bg-color-base-white color-base-darkgray"
                        onClick={()=>{
                            // Decrement search result index
                            handleResultIndexChange(resultIndex, -1, verResults);
                        }}
                    >
                        <div>
                            {ICONS.upCaret()}
                            <span class="visually-hidden">Previous</span>
                        </div>
                    </Button>
                    <Button 
                        title="Go to next search result"
                        disabled={totalResults==0  || verResults.length<1}
                        className="rounded-0 bg-color-base-white color-base-darkgray"
                        onClick={()=>{
                            // Increment search result index
                            handleResultIndexChange(resultIndex, 1, verResults);
                        }}
                    >
                        <div>
                            {ICONS.downCaret()}
                            <span class="visually-hidden">Next</span>
                        </div>
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default NavigationBar;